import { DancePoleIcon } from './DancePoleIcon';

/**
 * author: Haley Halcyon
 * id 45E2144E-5240-4557-B9A9-45DD7B514738
 * name dance-pole
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dance-pole.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const KhoKhoIcon = DancePoleIcon;
export default KhoKhoIcon